import PricingPlan from "./PricingPlan";
export default PricingPlan;

